import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

import { retry, catchError } from 'rxjs/operators';
import {HttpClient,HttpHeaders} from "@angular/common/http";

import { from as fromPromise,Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isLoggedIn = false;
  me:any = JSON.parse(localStorage.getItem("me"));
  private APIURL = environment.baseURL;


  constructor(
    public httpClient: HttpClient) { this.httpClient = httpClient; 
    }



  relogin(param:any): Observable<any> {

    return fromPromise(this.httpClient.post(`${this.APIURL}/auth/web/login`,param
    ));
  }

  login(param:any): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/auth/web/login`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  company_profile(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/company/user/${JSON.parse(localStorage.getItem("me")).user.id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  doc_list(type): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/company/document/${JSON.parse(localStorage.getItem("me")).user.id}?documentType=${type}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  upload_doc(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/company/upload`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }


  delete_doc(id): Observable<any> {
    return this.httpClient.delete(`${this.APIURL}/company/${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }


  view_doc(id): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/company/download?id=${id}`, { responseType: 'arraybuffer' 
    })
  }



  update_company_profile(param): Observable<any> {
    return this.httpClient.put(`${this.APIURL}/company/user/${JSON.parse(localStorage.getItem("me")).user.id}`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  

  profile(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/user/${JSON.parse(localStorage.getItem("me")).user.id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }


  update_profile(param): Observable<any> {
    return this.httpClient.put(`${this.APIURL}/user/profile/${JSON.parse(localStorage.getItem("me")).user.id}`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }


  update_password(param): Observable<any> {
    return this.httpClient.put(`${this.APIURL}/user/${JSON.parse(localStorage.getItem("me")).user.id}`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }


  register(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/auth/register`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }


  registerTrial(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/auth/trial`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  forgotPassword(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/auth/forgot`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  getCodeForgotPassword(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/auth/code`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  // admin
  admin_update_password(param,userId): Observable<any> {
    return this.httpClient.put(`${this.APIURL}/user/admin/${userId}`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  admin_delete_user(userId): Observable<any> {
    return this.httpClient.delete(`${this.APIURL}/user/superadmin/${userId}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  admin_add_user(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/user/superadmin`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  admin_update_user(param,id): Observable<any> {
    return this.httpClient.put(`${this.APIURL}/user/superadmin/${id}`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  admin_get_user(id): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/user/superadmin/${id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }


    private handleError(error: any): Observable<any> {
      return throwError(error);
    }
}
